__webpack_require__.p = "/so-yummy-project/";